import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, provide } from "vue";
import { ModelThrowComponentsTab } from "..";
import { TirPmTabsVariantEnum } from "./Enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
  variant: {
    type: String as PropType<TirPmTabsVariantEnum>,
    default: TirPmTabsVariantEnum.Primary,
  },
  modelValue: {
    default: null,
    type: [String, Number, Symbol] as PropType<ModelThrowComponentsTab>,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





provide("injectFromTab", (data: ModelThrowComponentsTab) => {
  emit("update:modelValue", data);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabs", {
      'tabs-secondary': props.variant == _unref(TirPmTabsVariantEnum).Secondary,
      'tabs-primary': props.variant == _unref(TirPmTabsVariantEnum).Primary,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})